import { cva } from "class-variance-authority";

export const tab = cva(
  "flex flex-1 p-size-x2 justify-center cursor-pointer hover:border-b-border-width-thick hover:border-b-th-primary-color-darkest hover:bg-neutral-100",
  {
    variants: {
      isFocused: {
        true: "border-b-border-width-thin border-th-primary-color-main",
      },
    },
  }
);
